import React from "react";
import "./Integrator.css";
import {
  Container,
  Col,
  Card,
  CardBody
} from "reactstrap";
//import CustomizedCertification from "../../Pages/BusinessBenefits/CustomizedCertification"
//import "react-accessible-accordion/dist/fancy-example.css";

export default class Integrator extends React.Component {
  render() {
    return (
      <div>

        <Container className="content-wrapper container">
          <Card className="col-md-10 offset-md-1 crt-box-block">
            <CardBody className="row">
              <Col md="6">
                <div className="small-text">DEVELOPER?</div>
                <p>
                  Get ahead of the competition, join the certified professionals
                  building integrations faster and smarter.
              </p>
              </Col>
              <Col
                md="6"
                className="align-self-center justify-content-center d-flex"
              >
                <a className="int-btn green-btn" href="/get-certified">GET CERTIFIED</a>
              </Col>
            </CardBody>
          </Card>
        </Container>
      </div>
    );
  }
}